module.exports = "<span class=\"rnpl-status-lbl\">{{value}}</span>\n\n"